const project = {
  name: "COLLES",
  address1: "Kanan Veng, RK Road",
  address2: "Aizawl, Mizoram - 796001",
  email: "collesmizo@gmail.com",
  contact: "+91 9612602728",
};
export default project;
